import { LangCode } from "@/lib/gql/__generated__/graphql";

export const isValidLandCode = (langCode: unknown): langCode is LangCode => {
	return Object.values(LangCode).includes(langCode as LangCode);
};
